//! Reminder preset times, computed in the user's local clock.
//!
//! The API stores an absolute instant, so the client turns "this evening" /
//! "tomorrow morning" into a concrete Date here — where the browser knows the
//! viewer's timezone and current time — rather than the server guessing.

export type ReminderPresetId = "in-1-hour" | "this-evening" | "tomorrow-morning" | "custom";

export interface ReminderPreset {
  id: ReminderPresetId;
  label: string;
  /** Absolute time to fire, or null for "custom" (the caller prompts). */
  at: (now?: Date) => Date | null;
}

/** 6pm counts as "evening"; 9am as "morning" — the same working-day anchors the
 *  rest of the app's reminders use. */
const EVENING_HOUR = 18;
const MORNING_HOUR = 9;

export const REMINDER_PRESETS: ReminderPreset[] = [
  {
    id: "in-1-hour",
    label: "In 1 hour",
    at: (now = new Date()) => new Date(now.getTime() + 60 * 60 * 1000),
  },
  {
    id: "this-evening",
    label: "This evening",
    at: (now = new Date()) => {
      const d = new Date(now);
      d.setHours(EVENING_HOUR, 0, 0, 0);
      // If it is already past 6pm, "this evening" has gone — roll to tomorrow
      // evening so the reminder is always in the future.
      if (d.getTime() <= now.getTime()) d.setDate(d.getDate() + 1);
      return d;
    },
  },
  {
    id: "tomorrow-morning",
    label: "Tomorrow morning",
    at: (now = new Date()) => {
      const d = new Date(now);
      d.setDate(d.getDate() + 1);
      d.setHours(MORNING_HOUR, 0, 0, 0);
      return d;
    },
  },
  {
    id: "custom",
    label: "Pick a date & time…",
    at: () => null,
  },
];
